/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from "react";
import clsx from "clsx";
import { toAbsoluteUrl } from "../../../helpers";
import {
  HeaderUserMenu,
  ThemeModeSwitcher
} from "../../../partials";
import { useAuth } from "../../../../app/modules/auth";

const toolbarButtonMarginClass = "ms-1 ms-lg-3",
  toolbarButtonHeightClass = "btn-active-light-primary btn-custom w-30px h-30px w-md-40px h-md-40p",
  toolbarUserAvatarHeightClass = "symbol-30px symbol-md-40px",
  toolbarButtonIconSizeClass = "svg-icon-1";

const Topbar: FC = () => {
  const { currentUser, setSelectedLanguage } = useAuth();

  const resetLanguageId = async () => {
    await setSelectedLanguage("", true);
  };

  return (
    <div className="d-flex align-items-stretch flex-shrink-0">
      <div className="topbar d-flex align-items-stretch flex-shrink-0">
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            resetLanguageId();
          }}
          className={clsx("btn btn-icon", toolbarButtonMarginClass)}
        >
          {currentUser?.language}
        </a>

        {/* begin::Theme mode */}
        <div className={clsx("d-flex align-items-center", toolbarButtonMarginClass)}>
          <ThemeModeSwitcher toggleBtnClass={toolbarButtonHeightClass} />
        </div>
        {/* end::Theme mode */}

        {/* begin::User */}
        <div
          className={clsx("d-flex align-items-center", toolbarButtonMarginClass)}
          id="kt_header_user_menu_toggle"
        >
          {/* begin::Toggle */}
          <div
            className={clsx("cursor-pointer symbol", toolbarUserAvatarHeightClass)}
            data-kt-menu-trigger="click"
            data-kt-menu-attach="parent"
            data-kt-menu-placement="bottom-end"
            data-kt-menu-flip="bottom"
          >
            <img
              className="h-30px w-30px rounded"
              src={toAbsoluteUrl("/media/avatars/300-2.jpg")}
              alt="metronic"
            />
          </div>
          <HeaderUserMenu />
          {/* end::Toggle */}
        </div>
        {/* end::User */}
      </div>
    </div>
  );
};

export { Topbar };
